import { useState } from 'react';
import Hero from './components/Hero';
import TiposOrtodoncia from './components/TiposOrtodoncia';
import CasosClinicos from './components/CasosClinicos';
import MejoresClinicas from './components/MejoresClinicas';
import DoctoresDestacados from './components/DoctoresDestacados';
import Contacto from './components/Contacto';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <TiposOrtodoncia />
      <CasosClinicos />
      <MejoresClinicas />
      <DoctoresDestacados />
      <Contacto />
      <Footer />
    </div>
  );
}